import CookieUtils from "./cookieUtils";

export const CONTENT_ONLY_QUERY_PARAM = "contentOnly";
export const CONTENT_ONLY_COOKIE_NAME = "content-only";
export const CONTENT_ONLY_SESSION_STORAGE = "content-only-tab";
export const CONTENT_ONLY_VALUE = "true";

export class ContentOnlyMode {
    public static init() {
        const search = new URLSearchParams(window.location.search);

        if (search.get(CONTENT_ONLY_QUERY_PARAM) !== "true") {
            const isCookieSet =
                CookieUtils.getCookieValue(CONTENT_ONLY_COOKIE_NAME) ===
                CONTENT_ONLY_VALUE;

            const isOriginalTab =
                sessionStorage.getItem(CONTENT_ONLY_SESSION_STORAGE) ===
                CONTENT_ONLY_VALUE;

            if (isCookieSet && !isOriginalTab) {
                CookieUtils.setCookie(
                    CONTENT_ONLY_COOKIE_NAME,
                    "false",
                    1,
                    "Lax",
                );

                window.location.reload();
            }

            return;
        }

        sessionStorage.setItem(
            CONTENT_ONLY_SESSION_STORAGE,
            CONTENT_ONLY_VALUE,
        );
        CookieUtils.setCookie(
            CONTENT_ONLY_COOKIE_NAME,
            CONTENT_ONLY_VALUE,
            1,
            "Lax",
        );
    }
}
